import { defineComponent } from 'navigation-components/platform/models';
import { getPortalId } from '../../common/utils';
import { NAV_ONBOARDING_TOURS_COMPONENT } from '../constants';
import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../constants/z_index';
import { capabilities } from '../../capabilities';
export const navOnboardingToursComponentDef = defineComponent(NAV_ONBOARDING_TOURS_COMPONENT, {
  name: NAV_ONBOARDING_TOURS_COMPONENT,
  path: `/nav-onboarding-tours/${getPortalId()}`,
  capabilities: [capabilities.RESTYLE_CAP.getName()],
  deferLoading: true,
  iframeProps: {
    style: {
      position: 'absolute',
      zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT,
      width: '0px',
      height: '0px'
    }
  }
});